IntlMessageFormat.__addLocaleData({"locale":"om","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"om-ET","parentLocale":"om"});
IntlMessageFormat.__addLocaleData({"locale":"om-KE","parentLocale":"om"});
